import React from "react";
import { connect } from "react-redux";
import Dashboard from "../../components/smart/Dashboard/Dashboard";
import { roles, dashboardType } from "../../modules/constants";
import { mapStateToPropsLogin } from "../../modules/login";

export const Charts = (props) => {
  const { userProfile } = props;
  return (
    <Dashboard
      type={
        userProfile === roles.participant
          ? dashboardType.participant
          : dashboardType.survey
      }
      {...props}
    />
  );
};

export default connect(mapStateToPropsLogin, null)(Charts);
